import { FC, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { SearchModal } from '../../search-modal';

import { ButtonSquare, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

export const WorkspaceSearch: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  // Mac + Windows
  useHotkeys(['meta+k', 'ctrl+k'], () => setIsOpen(true), {}, [setIsOpen]);

  return (
    <>
      {isOpen && <SearchModal onClose={onClose} />}
      <ButtonSquare
        variant="tertiary-gray"
        className="md:hidden h-8 w-8 rounded-lg hover:bg-base-black/[0.08]"
        onClick={() => setIsOpen(true)}
      >
        <Icon glyph={IconMap.SearchLg} width={20} />
      </ButtonSquare>
    </>
  );
};
